module.exports = __webpack_public_path__ + "img/step3-mobile-en.e4c9826b.webp";